// eslint-disable-next-line import/no-anonymous-default-export
export default {
  meEndpoint: '/auth/me',
  storageTokenKeyName: 'Lynksorg-admin-panel-web-accessToken',
  storageUserDataKeyName: 'Lynksorg-admin-panel-web-portal-userData',
}
